export default "__VITE_ASSET__WGPV75qb__"